import React from 'react';
import PropTypes from 'prop-types';

export default function LockIcon({ size, color, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 13 15" {...rest}>
      <path
        fill={color}
        d="M1.53846154,5.23559673 L2.76923077,5.23559673 C2.95384615,5.23559673 3.07692308,5.14328904 3.07692308,4.95867365 L3.07692308,4.92790442 C3.07692308,3.17405827 4.58461538,1.72790442 6.36923077,1.85098135 C8,1.97405827 9.23076923,3.38944289 9.23076923,5.05098135 L9.23076923,4.95867365 C9.23076923,5.14328904 9.35384615,5.23559673 9.53846154,5.23559673 L10.7692308,5.23559673 C10.9538462,5.23559673 11.0769231,5.14328904 11.0769231,4.95867365 L11.0769231,4.92790442 C11.0769231,2.12790442 8.73846154,-0.118249422 5.90769231,0.00482750098 C3.29230769,0.127904424 1.29230769,2.34328904 1.23076923,4.95867365 C1.26153846,5.11251981 1.38461538,5.23559673 1.53846154,5.23559673 L1.53846154,5.23559673 Z M12.3076923,7.69713519 C12.3076923,7.02021212 11.7538462,6.46636596 11.0769231,6.46636596 L1.23076923,6.46636596 C0.553846154,6.46636596 0,7.02021212 0,7.69713519 L0,13.543289 C0,14.2202121 0.553846154,14.7740583 1.23076923,14.7740583 L11.0769231,14.7740583 C11.7538462,14.7740583 12.3076923,14.2202121 12.3076923,13.543289 L12.3076923,7.69713519 Z"
      />
    </svg>
  );
}

LockIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

LockIcon.defaultProps = {
  size: 15,
  color: '#000',
};
